import React from 'react';
import { Confirm, useCreatePath, useDelete, useNotify, useRecordContext, useRedirect } from 'react-admin';
import { Box, Typography } from '@mui/material';
import CircleWarning from 'src/assets/CircleWarning';
import { deleteModalsStyles, interFontStyle } from 'src/styles';
import { ShsButton } from 'src/components/common';
import { NOTIFICATION_OPTIONS_SUCCESS, Resource } from '../../../constants';

export const DeleteEducationCenterModal: React.FC<any> = ({ isOpen, onClose }) => {
    const [deleteOne] = useDelete();
    const record = useRecordContext();
    const redirect = useRedirect();
    const notify = useNotify();
    const createPath = useCreatePath();

    const handleDeleteBtnClick = () => {
        deleteOne(
            Resource.CENTERS,
            { id: record.id },
            {
                mutationMode: 'pessimistic',
                onSuccess: () => {
                    notify('Видалення центру пройшло успішно', NOTIFICATION_OPTIONS_SUCCESS);
                    redirect(createPath({ resource: 'centers', type: 'list' }));
                    onClose();
                },
                onError: (error: any) => {
                    notify(`Помилка: ${error?.message}`, {
                        type: 'error'
                    });
                }
            }
        );
    };

    return (
        <>
            <Confirm
                isOpen={isOpen}
                loading={false}
                title={''}
                onConfirm={close}
                onClose={close}
                sx={deleteModalsStyles}
                content={
                    <>
                        <div className="shs-modal-header">
                            <Box sx={{ textAlign: 'center' }}>
                                <CircleWarning />
                            </Box>
                            <Typography variant="h5" component="h5" mb={2} mt={1} fontWeight="600" align="center">
                                Видалення освітнього центру
                            </Typography>
                        </div>
                        <div className="shs-modal-body">
                            <Typography component="div" mb={3} align="center" sx={interFontStyle}>
                                Чи впевнені ви що хочете видалити «{record?.name}»?
                            </Typography>
                            <Typography component="div" mb={4} align="center" sx={interFontStyle}>
                                Після видалення освітнього центру всі дані про нього, його працівників, учнів та
                                розклади в ньому будуть видалені й не підлягатимуть відновленню.
                            </Typography>
                        </div>
                        <div className="shs-modal-footer" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <ShsButton
                                label="Скасувати"
                                styleType="outline"
                                onClick={onClose}
                                sx={{ flex: '1', marginRight: '1em' }}
                            />
                            <ShsButton
                                label="Видалити"
                                styleType="filled-danger"
                                onClick={handleDeleteBtnClick}
                                sx={{ flex: '1' }}
                            />
                        </div>
                    </>
                }
            />
        </>
    );
};
